<template>
    <div>
        <div id="boxFixed" :class="{'is_fixed' : isFixed}" style="position: relative;z-index: 99;">
            <div :class="backColre">
                <div :class="headBox">
                    <div class="home-title"><span>布瑞琳</span> BRANEW</div>
                    <div class="home-header">
                        <router-link to="/" :class="headerList" :active-class="activeIndexColor" exact @click.native="changeRoute('/')">{{$t('header.home')}}</router-link>
                        <router-link to="/about" :class="headerList" :active-class="activeIndexColor" @click.native="changeRoute('/about')">{{$t('header.about')}}</router-link>
                        <router-link to="/stores" :class="headerList" :active-class="activeIndexColor" @click.native="changeRoute('/stores')">{{$t('header.stores')}}</router-link>
                        <router-link to="/help" :class="headerList" :active-class="activeIndexColor" @click.native="changeRoute('/help')">{{$t('header.help')}}</router-link>
                        <!-- <router-link to="/members" :class="headerList" :active-class="activeIndexColor" @click.native="changeRoute('/members')">{{$t('header.members')}}</router-link> -->
                        <!-- <span v-for="(item,index) in homeHeader" :key="index" @click="changeHomeHeader(item.path)" :class=" activeIndex == item.path ? activeIndexColor : '' "> {{item.title}} </span> -->
                    </div>
                    <!-- <div class="language"><span @click="changeLanguage('en')">EN</span> | <span @click="changeLanguage('zh')">中文</span></div> -->
                </div>
            </div>
        </div>
        
        <div id="mobileHeader">
            <img src="../assets/navigation.png" alt="">
            <span>布瑞琳  BRANEW</span>
            <img src="../assets/stores.png" alt="">
        </div>
    </div>
    
    
</template>

<script>
import bus from '@/components/bus';
import { mapState } from 'vuex';

export default {
  name: 'HeadNav',
//   props: {
//     msg: String
//   }

    data() {
        return {
            backColre: 'head-body',
            activeIndexColor:'active-index',
            headerList:'header-list',
            headBox:'head-box',
            homeHeader:[
                {
                    title: "首页",
                    path: "/"
                },
                {
                    title: "品牌理念",
                    path: "/about"
                },
                {
                    title: "门店分布",
                    path: "/stores"
                },
                {
                    title: "帮助中心",
                    path: "/help"
                },
                {
                    title: "会员中心",
                    path: "/members"
                },
            ],
            activeIndex: '/',
            isFixed: false,
            scrollHeight: 500,
        };
    },
    created() {
        console.log(this);
        console.log(this.$route.path);
        console.log(this.$router.currentRoute.path);

        bus.$on('changeRoute', value => {
            this.changeRoute(value);
        })
    },
    computed: {
        
    },
    mounted(){
        window.addEventListener("scroll", this.initHeight);
        this.$nextTick(() => {
            this.offsetTop = document.querySelector("#boxFixed").offsetTop;
        });

        let _this = this;
        setTimeout(function() {
            console.log(_this.$route, _this.$route.path);
            _this.changeRoute( _this.$route.path );
        }, 100);
    },
    methods: {
        changeLanguage(language) {
            this.$i18n.locale = language; //关键语句
            // if (this.language == "zh-CN") {
            //     this.language = "en-US";
            //     this.$i18n.locale = this.language; //关键语句
            //     this.addCookie("lang", this.language);
            // } else {
            //     this.language = "zh-CN";
            //     this.$i18n.locale = this.language; //关键语句
            //     this.addCookie("lang", this.language);
            // }
            // location.reload();
        },
        changeRoute(e){
            console.log(e);

            if(e != "/help"){
                // e != "/" && 
                console.log('蓝色显示状态');
                this.backColre = 'head-nav';
                this.activeIndexColor = 'active-index-color';
                this.headerList = 'header-list-active';
                this.headBox = 'head-box-active';

                if(e == "/newsInformation"){
                    this.headBox = 'head-box-active-news';
                }
            }else{
                console.log('白色未显示状态');
                this.backColre = 'head-body';
                this.activeIndexColor = 'active-index';
                this.headerList = 'header-list';
                this.headBox = 'head-box';
            }
        },
        // changeHomeHeader(item){
        //     // console.log(item);
        //     this.activeIndex = item;
        //     this.$router.push(item);

        //     if(item != "/"){
        //         this.backColre = 'head-nav';
        //         this.activeIndexColor = 'active-index-color';
        //     }else{
        //         this.backColre = 'head-body';
        //         this.activeIndexColor = 'active-index';
        //     }
        // },
        initHeight(){
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.isFixed = scrollTop > this.offsetTop ? true : false;
        },

//         $(function(){
// //判断页面是手机端还是pc端
// function IsPC() {
// var userAgentInfo = navigator.userAgent;
// var Agents = ["Android", "iPhone",
// "SymbianOS", "Windows Phone",
// "iPad", "iPod"];
// var flag = true;
// for (var v = 0; v < Agents.length; v++) {
// if (userAgentInfo.indexOf(Agents[v]) > 0) {
// flag = false;
// break;
// }
// }
// return flag;
// }
// var turl="";
// //如果是手机端打开
// if(!IsPC()){
// turl="http://m.i6tou.com/topic/sports";
// var _str=location.href.split('?')[1];
// if(typeof(_str)!="undefined"){
// turl=turl+"?"+_str;
// }
// window.location.href = turl;
// }
// });

    },
    destroyed(){
        window.removeEventListener("scroll", this.handleScroll);
    },
    watch:{

    },
  
}
</script>

<style scoped lang="scss">
.is_fixed{
    position: fixed;
    top: 0;
    z-index: 1000;
    width: 100%;

    .head-box{
        position: relative;
        overflow: hidden;
        border-bottom: 1px solid #00146E;
    }
    .header-list{
        color: #00146E;
    }

    .home-title{
        display: none;
    }

    .head-body{
        z-index: 1000;
        width: 100%;
        color: #00146E;
        background: #F3F5FA;
    }
    .head-nav{
        z-index: 1000;
        width: 100%;
        color: #00146E;
        background: #F3F5FA;
    }
    .language{
        position: absolute;
        right: 2rem;
        top: 0.7rem;
    }
    .active-index{
        color: #00146E;
        border-bottom: 4px solid #00146E;
    }
}

#boxFixed:hover{
    .head-box{
        position: relative;
        overflow: hidden;
        background: #F3F5FA;
        border-bottom: 1px solid #00146E;
        color: #00146E;
    }
    .header-list{
        color: #00146E;
    }
    .active-index{
        border-bottom: 4px solid #00146E;
    }
}
.head-body{
    z-index: 1000;
    width: 100%;
    color: #fff;
}
.head-nav{
    z-index: 1000;
    width: 100%;
    color: #00146E;
}
.head-box{
    position: relative;
    overflow: hidden;
}
.head-box-active{
    position: relative;
    overflow: hidden;
    border-bottom: 1px solid #00146E;
}
.head-box-active-news{
    position: relative;
    overflow: hidden;
    border-bottom: none;
}
.home-title{
    // color: #fff;
    font-size: 2rem;

    // span{
    //     font-weight: bolder;
    // }
}
// .home-header{
    .header-list{
        display: inline-block;
        height: 3rem;
        line-height: 3rem;
        margin: 0 1rem;
        cursor: pointer;
        text-decoration: none;
        color: #fff;
    }
    .header-list-active{
        display: inline-block;
        height: 3rem;
        line-height: 3rem;
        margin: 0 1rem;
        cursor: pointer;
        text-decoration: none;
        color: #00146E;
    }
// }
.active-index{
    border-bottom: 4px solid #fff;
}
.active-index-color{
    border-bottom: 4px solid #00146E;
}

.language{
    position: absolute;
    right: 2rem;
    top: 1.5rem;
    // color: #fff;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
}

#mobileHeader{
    display: none;
}

// @media screen and (max-width: 768px) {
//     #boxFixed{
//         display: none;
//     }
//     #mobileHeader{
//         display: block;
//         background: #00146E;
//         position: relative;
//         color: #fff;

//         img{
//             width: 3rem;
//         }
//     }
// }
</style>
